import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AppSnackBarInput } from './AppSnackBar';

interface AppContextType {
  // Add your app-wide state papperties here
  loading: boolean;
  setLoading: (loading: boolean) => void;
  snackbarInput: AppSnackBarInput;
  setSnackbarInput: (input: AppSnackBarInput) => void;
  
  // Example: You can add more state as needed
  // notifications: Notification[];
  // setNotifications: (notifications: Notification[]) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
}

export const AppContextProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [snackbarInput , setSnackbarInput] = useState<AppSnackBarInput>({message: '', severity: 'info'});
  
  // Add more state variables as needed
  
  const value: AppContextType = {
    loading,
    setLoading,
    snackbarInput,
    setSnackbarInput,
    // Add more context values here
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppContextProvider');
  }
  return context;
};

export default AppContext;